import { SendCandidateEvent } from "@domain";
import { BasePeerCommand } from "./BasePeerCommand";

export class SendCandidateCommand extends BasePeerCommand {
  public execute(event: CustomEvent<SendCandidateEvent>): void {
    const room = this.getRoom();
    this.signalingService.sendCandidate(
      room.id,
      event.detail.candidate,
      this.getRoomLocalParticipantRemoteId(),
      event.detail.to
    );
  }
}
